(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("d3"), require("react"), require("moment-timezone"), require("prop-types"));
	else if(typeof define === 'function' && define.amd)
		define(["d3", "react", "moment-timezone", "prop-types"], factory);
	else if(typeof exports === 'object')
		exports["Icons"] = factory(require("d3"), require("react"), require("moment-timezone"), require("prop-types"));
	else
		root["Hologram"] = root["Hologram"] || {}, root["Hologram"]["Icons"] = factory(root["d3"], root["react"], root["moment-timezone"], root["prop-types"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__11__, __WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__53__) {
return 